<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ii"></a><em>Also by Fay Weldon</em></p>
<p class="noindent">Fiction</p>
<p class="noindent"><span class="small">THE FAT WOMAN’S JOKE</span><br/><span class="small">DOWN AMONG THE WOMEN</span><br/><span class="small">FEMALE FRIENDS</span><br/><span class="small">REMEMBER ME</span><br/><span class="small">LITTLE SISTERS</span><br/><span class="small">PRAXIS</span><br/><span class="small">PUFFBALL</span><br/><span class="small">THE PRESIDENT’S CHILD THE LIFE AND LOVES OF A SHE-DEVIL</span><br/><span class="small">THE SHRAPNEL ACADEMY</span><br/><span class="small">THE HEART OF THE COUNTRY</span><br/><span class="small">THE HEARTS AND LIVES OF MEN</span><br/><span class="small">THE RULES OF LIFE</span><br/><span class="small">LEADER OF THE BAND</span><br/><span class="small">THE CLONING OF JOANNA MAY</span><br/><span class="small">DARCY’S UTOPIA</span><br/><span class="small">GROWING RICH</span><br/><span class="small">LIFE FORCE</span><br/><span class="small">AFFLICTION</span><br/><span class="small">SPLITTING</span><br/><span class="small">WORST FEARS</span><br/><span class="small">BIG GIRLS DON’T CRY</span><br/><span class="small">RHODE ISLAND BLUES</span><br/><span class="small">THE BULGARI CONNECTION</span></p>
<p class="noindent">Children’s Books</p>
<p class="noindent"><span class="small">WOLF THE MECHANICAL DOG</span><br/><span class="small">NOBODY LIKES ME</span></p>
<p class="noindent">Short-Story Collections</p>
<p class="noindent"><span class="small">WATCHING ME, WATCHING YOU</span><br/><span class="small">POLARIS</span><br/><span class="small">MOON OVER MINNEAPOLIS</span><br/><span class="small">WICKED WOMEN</span><br/><span class="small">A HARD TIME TO BE A FATHER</span><br/><span class="small">NOTHING TO WEAR &amp; NOWHERE TO HIDE</span></p>
<p class="noindent">Nonfiction</p>
<p class="noindent"><span class="small">LETTERS TO ALICE</span><br/><span class="small">REBECCA WEST</span><br/><span class="small">SACRED COWS</span><br/><span class="small">GODLESS IN EDEN</span><br/><span class="small">AUTO DA FAY</span><br/><span class="small">MANTRAPPED</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front1.vue?06ade922